import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const deleteSystemUser = async (unitId?: string, userId?: number): Promise<boolean> =>
  axios.delete(`/my-monitoring/sites/RemoveSystemUser?unitId=${unitId}&userId=${userId}`).then((res) => res?.data?.result)

type Props = {
  unitId?: string
  userId?: number
}

export const useMyMonitoringDeleteSystemUser = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteMyMonitoringSiteSystemUser'],
    mutationFn: ({ unitId, userId }: Props) => deleteSystemUser(unitId, userId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Removed user.')
      }
    },
    onError: (error) => {
      if (notify) {
        console.log('error', error?.message || 'Failed to remove user.')
        toastError(error?.message || 'Failed to remove user.')
      }
    },
    throwOnError: false
  })
